import { render, staticRenderFns } from "./orderMangDialog.vue?vue&type=template&id=5552e4d3&scoped=true&"
import script from "./orderMangDialog.vue?vue&type=script&lang=js&"
export * from "./orderMangDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderMangDialog.vue?vue&type=style&index=0&id=5552e4d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5552e4d3",
  null
  
)

export default component.exports